module.exports = "images/apple-icon-76x76.7b7cd0a0264683656499aa477bea3faf.png";